"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefreshBtn = void 0;
var react_1 = __importDefault(require("react"));
require("./index.less");
/** 表格刷新按钮 */
function RefreshBtn() {
    var refresh = function (e) {
        self.location.reload();
        e.preventDefault();
    };
    return (react_1.default.createElement("a", { className: "refresh_link", href: "#", onClick: refresh }, "\u67E5\u770B\u6700\u65B0"));
}
exports.RefreshBtn = RefreshBtn;
